import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
export default {
  name: "HanoiTowerInferenceRender",
  props: {
    difficulty: {
      type: Object,
      default: () => ({})
    },
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      digits: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      answerSlots: [null, null, null, null],
      activeIndex: 0
    };
  },
  computed: {
    correctAnswers() {
      return this.parseAnswer(this.data?.rightAnswer);
    },
    reviewAnswers() {
      return this.parseAnswer(this.review?.answer);
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.resetState();
      }
    },
    review: {
      deep: true,
      handler() {
        this.resetState();
      }
    },
    reviewMode() {
      this.resetState();
    }
  },
  methods: {
    parseAnswer(answer) {
      if (!answer) {
        return [];
      }
      return answer.split(',').map(item => item.trim()).filter(item => item !== '').map(item => Number(item)).filter(item => !Number.isNaN(item));
    },
    resetState() {
      const answers = this.reviewMode ? this.reviewAnswers : [];
      this.answerSlots = Array.from({
        length: 4
      }, (_, index) => {
        return answers[index] != null ? answers[index] : null;
      });
      this.activeIndex = this.answerSlots.findIndex(item => item === null);
      if (this.activeIndex < 0) {
        this.activeIndex = 3;
      }
      this.emitAnswer();
    },
    setActive(index) {
      if (this.reviewMode) {
        return;
      }
      this.activeIndex = index;
    },
    inputDigit(num) {
      if (this.reviewMode) {
        return;
      }
      this.answerSlots.splice(this.activeIndex, 1, num);
      const nextEmpty = this.answerSlots.findIndex((item, index) => item === null && index > this.activeIndex);
      if (nextEmpty >= 0) {
        this.activeIndex = nextEmpty;
      } else if (this.activeIndex < this.answerSlots.length - 1) {
        this.activeIndex += 1;
      }
      this.emitAnswer();
    },
    removeDigit() {
      if (this.reviewMode) {
        return;
      }
      if (this.answerSlots[this.activeIndex] != null) {
        this.answerSlots.splice(this.activeIndex, 1, null);
      } else {
        const prevFilled = [...this.answerSlots].map((item, index) => ({
          item,
          index
        })).filter(({
          item,
          index
        }) => item != null && index < this.activeIndex).pop();
        if (prevFilled) {
          this.activeIndex = prevFilled.index;
          this.answerSlots.splice(this.activeIndex, 1, null);
        }
      }
      this.emitAnswer();
    },
    clearDigits() {
      if (this.reviewMode) {
        return;
      }
      this.answerSlots = [null, null, null, null];
      this.activeIndex = 0;
      this.emitAnswer();
    },
    emitAnswer() {
      const answer = this.answerSlots.every(item => item != null) ? this.answerSlots.join(',') : null;
      this.$emit('answer', answer);
    },
    ruleLabel(rule) {
      const labels = {
        RED_COUNT: "红环数",
        BLUE_COUNT: "蓝环数",
        PRODUCT: "红蓝乘积",
        DIFF: "红蓝差值"
      };
      return labels[rule] || rule;
    }
  },
  mounted() {
    this.resetState();
  }
};